import { UserStatus } from 'models/userStatus';
import { PartnerDetailsDTO } from 'models/higoDevice';

export interface ProfileOwnerUserDeviceDTO {
  id: number;
  serialNumber: string;
}

export interface ProfileOwnerFormModel {
  partner?: any;
  dateOfBirth?: string;
  email: string;
  firstName: string;
  gender?: string;
  idNumber: string;
  lastName: string;
  phoneNumber: string;
  prefixCode: string;
  id: number;
  status: UserStatus;
  userId: number;
}

export interface ProfileOwnerDTO {
  partnerDetails?: PartnerDetailsDTO;
  assignedDevice?: ProfileOwnerUserDeviceDTO;
  dateOfBirth?: string;
  email: string;
  firstName: string;
  gender?: string;
  id: number;
  idNumber: string;
  lastName: string;
  phoneNumber: string;
  pin?: string;
  prefixCode: string;
  status: UserStatus;
  userId: number;
}

export type ProfileOwner = ProfileOwnerDTO;
export type ProfileOwnerExcerptDTO = Pick<
  ProfileOwnerDTO,
  'userId' | 'firstName' | 'lastName'
>;

// RegisterBusinessPartnerUserDTO
export type RegisterBusinessPartnerProfileOwnerDTO = Omit<
  Required<ProfileOwnerDTO>,
  'id' | 'pin' | 'status' | 'userId' | 'assignedDevice' | 'partnerDetails'
>;

export enum ProfileOwnerTransferOption {
  WithProfiles = 'WITH_PROFILES',
  WithProfilesAndExams = 'WITH_PROFILES_AND_EXAMS',
}

export const profileOwnerTransferLabelMap = new Map<
  ProfileOwnerTransferOption,
  string
>([
  [
    ProfileOwnerTransferOption.WithProfiles,
    'familyUsers.transfer.withProfiles',
  ],
  [
    ProfileOwnerTransferOption.WithProfilesAndExams,
    'familyUsers.transfer.withProfilesAndExams',
  ],
]);

export interface UserSettingsDTO {
  code: string;
  value: string;
}

export enum UserProfileSetting {
  Language = 'LANGUAGE',
}
